import React from 'react';

function Gallery() {
  return (
    <div className="gallery-page">
      <h1>Gallery</h1>
      <div className="gallery-grid">
        <img src="/gallery-placeholder1.png" alt="Match 1" />
        <img src="/gallery-placeholder2.png" alt="Match 2" />
        {/* Add more images */}
      </div>
    </div>
  );
}

export default Gallery;